// Formatage FR pour montants en euros.
// - 1000 €    si le montant est entier (pas de ",00" inutile)
// - 75,50 €   si centimes nécessaires
// - utilise l'espace insécable pour les milliers, virgule pour les décimales.
export function formatEuros(amount) {
  if (amount == null) return "—";
  const n = Number(amount);
  if (Number.isNaN(n)) return "—";
  const isInteger = Math.abs(n - Math.round(n)) < 0.005;
  const formatter = new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: isInteger ? 0 : 2,
    maximumFractionDigits: isInteger ? 0 : 2,
  });
  return formatter.format(n);
}
